import React from "react";
import {css} from "@panda/css";

import {SearchBoldIcon} from "@pg-design/icons-module";
import {noop} from "@pg-mono/nodash";

import {MobileOptionsModal} from "../../../atoms/MobileOptionsModal";
import {SearchAutocomplete} from "../../../search/components/search_autocomplete/SearchAutocomplete";
import {HomepageLegacyMobileSearchPlaceholder} from "./HomepageLegacyMobileSearchPlaceholder";
import {HomepageSearchDropdownList} from "./HomepageSearchDropdownList";
import {IHomepageSearchViewProps} from "./HomepageSearchTypes";

export const HomepageLegacyMobileSearch = (props: IHomepageSearchViewProps) => {
    return (
        <div className={legacyMobileWrapperStyle}>
            <HomepageLegacyMobileSearchPlaceholder onClick={() => props.setMobileSearchActive(true)} />

            <MobileOptionsModal modalHeading="Wyszukiwanie" isOpen={props.isMobileSearchActive} onModalClose={() => props.setMobileSearchActive(false)}>
                <SearchAutocomplete
                    values={props.formValues}
                    onChange={props.onChange}
                    onAfterChange={props.onAfterChange}
                    onSubmit={props.autocompleteSubmit}
                    onDropdownStatusChange={noop}
                    onAfterTabSwitch={props.onAfterTabSwitch}
                    fetchAllSearchLists={props.fetchAllSearchLists}
                    autoFocus={props.autoFocus ?? true}
                    isInModal
                    disableMultiRegion={!!props.disableMultiRegion}
                    inputIcon={<SearchBoldIcon size="2.4" />}
                    minWidth="auto"
                    renderDropdownList={HomepageSearchDropdownList}
                />
            </MobileOptionsModal>
        </div>
    );
};

const legacyMobileWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "80%",
    maxWidth: "552px",

    md: {
        display: "none"
    }
});
import React from "react";
import {css} from "@panda/css";

import {SearchBoldIcon} from "@pg-design/icons-module";
import {noop} from "@pg-mono/nodash";

import {MobileOptionsModal} from "../../../atoms/MobileOptionsModal";
import {SearchAutocomplete} from "../../../search/components/search_autocomplete/SearchAutocomplete";
import {HomepageLegacyMobileSearchPlaceholder} from "./HomepageLegacyMobileSearchPlaceholder";
import {HomepageSearchDropdownList} from "./HomepageSearchDropdownList";
import {IHomepageSearchViewProps} from "./HomepageSearchTypes";

export const HomepageLegacyMobileSearch = (props: IHomepageSearchViewProps) => {
    return (
        <div className={legacyMobileWrapperStyle}>
            <HomepageLegacyMobileSearchPlaceholder onClick={() => props.setMobileSearchActive(true)} />

            <MobileOptionsModal modalHeading="Wyszukiwanie" isOpen={props.isMobileSearchActive} onModalClose={() => props.setMobileSearchActive(false)}>
                <SearchAutocomplete
                    values={props.formValues}
                    onChange={props.onChange}
                    onAfterChange={props.onAfterChange}
                    onSubmit={props.autocompleteSubmit}
                    onDropdownStatusChange={noop}
                    onAfterTabSwitch={props.onAfterTabSwitch}
                    fetchAllSearchLists={props.fetchAllSearchLists}
                    autoFocus={props.autoFocus ?? true}
                    isInModal
                    disableMultiRegion={!!props.disableMultiRegion}
                    inputIcon={<SearchBoldIcon size="2.4" />}
                    minWidth="auto"
                    renderDropdownList={HomepageSearchDropdownList}
                />
            </MobileOptionsModal>
        </div>
    );
};

const legacyMobileWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "80%",
    maxWidth: "552px",

    md: {
        display: "none"
    }
});
